import { useEffect, useRef, useState } from "react";
import FloatingCardsGallery from "@/components/floating-cards/FloatingCardsGallery";
import { useSectionInView } from "@/lib/useSectionInView";

/** Portfolio detail intro — 3D card gallery (replaces Spline intro iframe). */
export default function PortfolioDetailIntroGallery() {
  const { ref, inView } = useSectionInView({ rootMargin: "120px 0px" });
  const [entryProgress, setEntryProgress] = useState(0);
  const rafRef = useRef(null);
  const startRef = useRef(null);

  useEffect(() => {
    if (!inView) return undefined;

    startRef.current = null;
    const durationMs = 1200;

    const tick = (now) => {
      if (startRef.current === null) startRef.current = now;
      const t = Math.min((now - startRef.current) / durationMs, 1);
      setEntryProgress(t);
      if (t < 1) rafRef.current = requestAnimationFrame(tick);
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [inView]);

  return (
    <div ref={ref} className="ds-portfolio-detail__intro-gallery" data-testid="portfolio-intro-gallery">
      <FloatingCardsGallery
        variant="portfolio"
        entryProgress={entryProgress}
        inView={inView}
        autoCycle
        showHints
        hintOpacity={Math.min(entryProgress * 1.2, 1)}
        testId="portfolio-intro-cards"
      />
    </div>
  );
}
